import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../../components/Layout';
import Content from '../../../../components/Pages/Trainings/Create/Gym';

const { displayName } = config;

function TrainingCreateGym(): React.JSX.Element {
  document.title = `${displayName}: Добавить тренировку (зал)`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
}

export default TrainingCreateGym;
